import React from "react";
import { FC, JSX } from "react";
import CoverCarousel from "@/components/CoverCarousel/CoverCarousel";
import { ElgigantenHomeCarouselData } from "branchAndBrandSpecific/features/home/constants/home.carousel";
import { Heading, Grid, Flex, Text, Strong } from "@radix-ui/themes";

const HomePageElgiganten: FC = (): JSX.Element => {
  return (
    <div className="home">
      <CoverCarousel slides={ElgigantenHomeCarouselData} interval={12000} />
      <Heading as="h2" size={{ initial: "7", md: "8" }} my="3">
        Assembly Summer 2025
      </Heading>
      <Flex direction="column" gap="4">
        <Text weight="light" size="4">
          Gigantti returns as a Main Partner of Assembly Summer – get ready for
          a massive gaming store, surprises, and top-tier brands.
        </Text>
        <Text as="p" size="3">
          At Assembly, we’re bringing an immersive 800 m² gaming store
          experience to life – packed with a wide selection of products ranging
          from accessories and components to the most requested new arrivals in
          Gaming Merchandise.
        </Text>
        <Text as="p" size="3">
          Our section is staffed by industry professionals who can offer the
          latest insights and personal guidance, whether you’re upgrading your
          setup or building a new gaming PC from scratch.
        </Text>
        <Text as="p" size="3">
          You’ll also find exciting activations just next to us in collaboration
          with the Red Bull Sphere — expect hands-on experiences and non-stop
          action throughout the event!
        </Text>
      </Flex>
      <Grid columns={{ initial: "1", md: "2" }} gap="4" mt="6">
        <Flex direction="column" gap="4">
          <Flex direction="column" gap="2">
            <Heading as="h3" size="5">
              Show Offers & Program
            </Heading>
            <Text as="p" size="3">
              <Strong>
                Thursday 31.7. 18:00 – Expo-lava: Ultimate Gaming Quiz.{" "}
              </Strong>
              Gigantti presents an epic quiz on the Expo Stage, where one lucky
              contestant gets to test their knowledge in a well-known quiz
              format with Gaming-themed questions. The contestant has the chance
              to walk away with the Ultimate Prize – something truly
              unforgettable!
            </Text>
          </Flex>
          <Text as="p" size="3">
            <Strong>
              Friday 1.8. 17:00 – Main Stage: Gigantti Gaming Giveaway{" "}
            </Strong>
            It’s full throttle on the Main Stage on Friday as the Gigantti
            Gaming Giveaway takes over! Expect loads of awesome Gigantti Gaming
            merch, exclusive items from our partners, and Gaming products worth
            thousands of euros. Don’t miss this spectacle – Gigantti Gaming and
            its partners are bringing their A-game!
          </Text>
          <Text as="p" size="3">
            <Strong>
              Saturday 2.8. 16:00 – Main Stage: Gigantti Gaming Giveaway
            </Strong>
            Saturday brings another round of high-energy action on the Main
            Stage as the Gigantti Gaming Giveaway returns! Tons of Gigantti
            Gaming merch, partner goodies, and incredible Gaming products worth
            thousands of euros will be up for grabs. Don’t miss out – Gigantti
            Gaming and its partners are going all in!
          </Text>
        </Flex>

        <Flex direction="column" gap="4">
          <Flex direction="column" gap="2">
            <Heading as="h3" size="5">
              In collaboration with Red Bull Gaming Sphere:
            </Heading>
            <Text as="p" size="3">
              <Strong>Friday 1.8. 19:00 – CS2 Wingman -tournament</Strong>
              On Friday from 19:00 to 21:00, Gigantti hosts an 8-team CS2
              Wingman tournament at the Red Bull Gaming Sphere. The winning duo
              will receive amazing product prizes from AOC! Registration is open
              on the event day at the Sphere.
            </Text>
          </Flex>
          <Text as="p" size="3">
            <Strong>Saturday 2.8. 13:00 – CS2 Wingman -tournament </Strong>
            On Saturday from 13:00 to 15:00, Gigantti hosts another 8-team CS2
            Wingman tournament at the Red Bull Gaming Sphere. The winning pair
            will take home fantastic AOC product prizes! Registration is open on
            the event day at the Sphere.
          </Text>
        </Flex>
      </Grid>
    </div>
  );
};

export default HomePageElgiganten;
